module.exports = __webpack_public_path__ + "assets/980686327b6240b86a8cb20f797cf9de.svg";